import { render, staticRenderFns } from "./sysNotice.vue?vue&type=template&id=739f4032&"
import script from "./sysNotice.vue?vue&type=script&lang=js&"
export * from "./sysNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports